import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AgreeButton from '../../common/VotingButtons/AgreeButton';
import DisagreeButton from '../../common/VotingButtons/DisagreeButton';
import LikeButton from '../../common/VotingButtons/LikeButton';
import VoteCard from './Card';
import './styles.scss';

class CardDeck extends Component {
  render() {
    const { questions, likes, currentIndex, onDisagreeClick, onAgreeClick, onLikeToggle } = this.props;
    return (
      <div className="cards-deck">
        <div className="cards-with-browser">
          <div className="cards">
            {questions.map((question, index) => {
              const top = currentIndex === index;
              const seen = currentIndex >= index;
              return (
                <div
                  key={question.id}
                  className="vote-card-wrapper"
                  style={{
                    ...(top && { position: 'relative' }),
                    zIndex: Number(top),
                    opacity: Number(seen),
                    transition: top && '.4s ease-out'
                  }}
                >
                  <VoteCard explanation={question.explanation} text={question.text} top={top} />
                </div>
              );
            })}
          </div>
          {questions.length - 1 >= currentIndex + 1 && <div className="vote-card-first-shadow" />}
          {questions.length - 2 >= currentIndex + 1 && <div className="vote-card-second-shadow" />}
        </div>
        <div className="card-buttons">
          <DisagreeButton onClick={onDisagreeClick} />
          <LikeButton isActive={!!likes[questions[currentIndex].id]} onClick={onLikeToggle} />
          <AgreeButton onClick={onAgreeClick} />
        </div>
      </div>
    );
  }
}

CardDeck.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  onAgreeClick: PropTypes.func.isRequired,
  onDisagreeClick: PropTypes.func.isRequired,
  onLikeToggle: PropTypes.func.isRequired,
  questions: PropTypes.array.isRequired,
  likes: PropTypes.object.isRequired
};

export default CardDeck;
